import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiper = new Swiper("#js-homeMemberSwiper", {
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      spaceBetween: 15,
    },
  },
  loop: true,
  slidesPerView: "auto",
  spaceBetween: 25,
});
